export default {"src":"/_next/static/media/octopus.573a5b8c.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};